"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var Cosmos_1 = __importDefault(require("./Cosmos"));
var Juno_1 = __importDefault(require("./Juno"));
var Osmosis_1 = __importDefault(require("./Osmosis"));
var cosmosChainParams = {};
function cryptoFactory(currencyId) {
    if (currencyId === "osmosis" || currencyId === "osmo") {
        if (!cosmosChainParams["osmo"]) {
            cosmosChainParams["osmo"] = new Osmosis_1["default"]();
        }
        return cosmosChainParams["osmo"];
    }
    else if (currencyId === "cosmos") {
        if (!cosmosChainParams[currencyId]) {
            cosmosChainParams[currencyId] = new Cosmos_1["default"]();
        }
        return cosmosChainParams[currencyId];
    }
    else if (currencyId === "juno") {
        if (!cosmosChainParams[currencyId]) {
            cosmosChainParams[currencyId] = new Juno_1["default"]();
        }
        return cosmosChainParams[currencyId];
    }
    else {
        throw new Error("".concat(currencyId, " is not supported"));
    }
    // TODO: Currently, all cosmos currencies included setSupportedCurrencies must be supported here. We are working on a new way to support/enable new currencies
}
exports["default"] = cryptoFactory;
//# sourceMappingURL=chain.js.map